import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Autocomplete from './autocomplete';
import Textarea from './textarea';
import Input from './input';
import Json from './json';
import View from './view';
import Images from './images';
import ImageList from './imagelist';
import Array from './array';

import util from '../../lib/util';

@observer
class FormRow extends Component {
    render() {
        const {
            field, object, saved, updateField, updateFieldId, level = 0,
        } = this.props;
        const name = `${field.namePrefix || ''}${field.name}${field.nameSuffix || ''}`;
        const value = util.getNestedValue(object, name);

        if (!field.view && typeof value === 'object' && value !== null && field.type === 'object') {
            const keys = field.keys || Object.keys(value);
            return <div>
                {keys.map((key) => {
                    return <FormField
                        level={level}
                        field={{
                            labelPrefix: name,
                            name: key,
                            namePrefix: `${name}.`,
                            readonly: field.readonly,
                            readonlyRef: field.readonlyRef,
                            type: field.type,
                            help: field.help,
                            imagePrefix: field.imagePrefix,
                        }}
                        object={object}
                        saved={saved}
                        updateField={updateField}
                        updateFieldId={updateFieldId}
                    />;
                })}
            </div>;
        }
        return <FormField
            level={level}
            field={{
                ...field,
                updateField,
            }}
            object={object}
            saved={saved}
            updateField={updateField}
            updateFieldId={updateFieldId}
            imagePrefix={field.imagePrefix}
        />;
    }
}

@observer
class ChooseField extends Component {
    render() {
        const {
            field, object, saved, updateField, updateFieldId, level, isCheckbox, imagePrefix,
        } = this.props;
        const name = `${field.namePrefix || ''}${field.name}${field.nameSuffix || ''}`;
        const value = isCheckbox ? (field.value || 'true') : util.getNestedValue(object, name);
        const isObject = typeof value === 'object' && value !== null;
        const isArray = typeof value === 'object' && util.isArray([]);
        const isString = typeof value === 'string';
        const isNumber = typeof value === 'number';
        const isBoolean = typeof value === 'boolean';

        let newValue = isCheckbox ? !util.getNestedValue(object, name) : null;
        if (isCheckbox && field.value === 1) {
            newValue = util.getNestedValue(object, name) ? 0 : 1;
        }
        const isMultiline = isString && (value.match(/\n/) || value.length > 100);
        const objectIdField = updateFieldId || 'id';
        const objectId = object[objectIdField];
        const readonlyRefIsDefined = field.readonlyRef && field.readonlyRef.hasOwnProperty(field.name);
        const readonly = readonlyRefIsDefined ? field.readonlyRef[field.name] : field.readonly;

        if (field.view) {
            return <View
                {...field}
                id={objectId}
                name={name}
                value={value}
                updateField={updateField}
                object={object}
            />;
        }

        if (field.type === 'images') {
            return <Images
                {...field}
                isValid={saved[`${name}.${objectId}`]}
                id={objectId}
                name={name}
                value={value}
                updateField={updateField}
                imagePrefix={imagePrefix}
                object={object}
            />;
        }

        if (field.type === 'imageList') {
            return <ImageList
                {...field}
                isValid={saved[`${name}.${objectId}`]}
                id={objectId}
                name={name}
                value={value}
                updateField={updateField}
                imagePrefix={imagePrefix}
                object={object}
            />;
        }

        if (field.type === 'array' || (!field.type && isArray)) {
            return <Array
                {...field}
                id={objectId}
                name={name}
                value={value}

                {...field}
                rows={7}
                readonly={readonly}
                isValid={saved[`${name}.${objectId}`]}
                onInput={e => updateField(objectId, name, e.target.value, field.type)}
                object={object}
            />;
        }

        if (field.type === 'json') {
            return <Json
                {...field}
                id={objectId}
                name={name}
                value={value}
            />;
        }

        if (isObject && field.type === 'object') {
            return <FormRow
                level={level + 1}
                field={{
                    ...field,
                }}
                saved={saved}
                updateField={updateField}
                updateFieldId={updateFieldId}
                object={object}
            />;
        }

        if (field.type === 'textarea' || isMultiline) {
            return <Textarea
                {...field}
                rows={7}
                readonly={readonly}
                id={objectId}
                isValid={saved[`${name}.${objectId}`]}
                name={name}
                value={value}
                onInput={e => updateField(objectId, name, e.target.value, object)}
                object={object}
            />;
        }

        if (['checkbox'].indexOf(field.type) >= 0 || isBoolean || isCheckbox) {
            return <Input
                {...field}
                readonly={readonly}
                type='checkbox'
                id={objectId}
                isValid={saved[`${name}.${objectId}`]}
                isCheckbox={isCheckbox}
                name={name}
                value={value}
                onInput={e => updateField(objectId, name, newValue, object)}
                checked={isCheckbox && util.getNestedValue(object, name) ? 'checked' : false}
                object={object}
            />;
        }
        
        if (['radio'].indexOf(field.type) >= 0) {
            return <Input
                {...field}
                readonly={readonly}
                type='radio'
                id={objectId}
                isValid={saved[`${name}.${objectId}`]}
                isCheckbox={isCheckbox}
                name={name}
                value={value}
                onInput={e => updateField(objectId, name, e.target.value, object)}
                checked={isCheckbox && util.getNestedValue(object, name) ? 'checked' : false}
                object={object}
            />;
        }

        if (['text', 'number'].indexOf(field.type) >= 0 || isNumber || isString) {
            return <Input
                {...field}
                readonly={readonly}
                id={objectId}
                isValid={saved[`${name}.${objectId}`]}
                name={name}
                value={value}
                onInput={e => updateField(objectId, name, e.target.value, object)}
                object={object}
            />;
        }

        return <Json
            {...field}
            id={objectId}
            name={name}
            value={value}
        />;
    }
}

@observer
class FormField extends Component {
    render() {
        const { field = {}, object = {}, saved = {}, updateField = () => {}, updateFieldId, level, imagePrefix } = this.props;
        const name = `${field.namePrefix || ''}${field.name}${field.nameSuffix || ''}`;
        const value = util.getNestedValue(object, name);
        let isCheckbox = false;
        if (field.type === 'object' && typeof value === 'boolean') {
            isCheckbox = true;
        } else if (field.type === 'checkbox') {
            isCheckbox = true;
        } else if (typeof value === 'boolean') {
            isCheckbox = true;
        }
        const objectIdField = updateFieldId || 'id';
        const objectId = object[objectIdField];
        // console.log('isCheckbox', name, field.type, typeof value, value, isCheckbox);

        return (
            <div class={`${isCheckbox ? 'form-group' : 'form-group'} row`}>
                <label for={`input${name}-${objectId}`} class='col-sm-2 col-form-label'>
                    {level === 0 && field.labelPrefix ? `${field.labelPrefix}.` : ''}
                    {field.label || <span>
                        {field.name} <span class='font-weight-lighter text-muted'>(no label)</span>
                    </span>}<br />
                    <small class='text-muted font-weight-lighter'>{field.aliasFor ? `${field.aliasFor} -> ` : ''} {field.name}</small>
                </label>
                <div class='col-sm-10'>
                    <ChooseField
                        field={field}
                        object={object}
                        saved={saved}
                        imagePrefix={imagePrefix}
                        updateField={updateField}
                        updateFieldId={updateFieldId}
                        level={level}
                        isCheckbox={isCheckbox}
                    />
                    {/* <xmp>{JSON.stringify(field, null, 4)}</xmp> */}
                </div>
            </div>
        );
    }
}

export default FormField;
export { FormRow };



// WEBPACK FOOTER //
// ./components/form/formField.js